"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keycloakJs = _interopRequireDefault(require("keycloak-js"));
var _utils = require("./utils.js");
let _kc;
const initKeycloak = (initialConfig, initOptions, onAuthenticatedCallback, handleEvent) => {
  const config = {
    url: initialConfig.url,
    clientId: initialConfig.clientId,
    realm: initialConfig.realm
  };
  const onComplete = () => {
    initialConfig?.onComplete?.();
  };
  _kc = new _keycloakJs.default(config);
  _kc.init(initOptions ?? {
    onLoad: 'check-sso'
    //   silentCheckSsoRedirectUri:
    //     window.location.origin + "/silent-check-sso.html",
    //   pkceMethod: "S256",
  }).then(authenticated => {
    if ((0, _utils.isPublicUrl)(initialConfig.publicUrls) && !authenticated) {
      onComplete();
    } else if (!authenticated) {
      console.log('user is not authenticated..!');
      _kc?.login?.();
    } else {
      if (_kc) onAuthenticatedCallback(_kc);
      onComplete();
    }
  }).catch(err => handleEvent?.('Error', err));
};
const doLogin = () => _kc?.login?.();
const logout = () => _kc?.logout?.();
const getToken = () => _kc?.token;
const isLoggedIn = () => !!_kc?.token;
const updateToken = successCallback => _kc?.updateToken?.(5)?.then?.(successCallback)?.catch(doLogin);
const getUsername = () => _kc?.tokenParsed?.preferred_username;
const hasRole = roles => roles.some(role => _kc?.hasRealmRole(role));
const UserService = {
  initKeycloak,
  doLogin,
  logout,
  isLoggedIn,
  getToken,
  updateToken,
  getUsername,
  hasRole,
  keycloak: () => _kc
};
var _default = exports.default = UserService;
module.exports = exports.default;
module.exports.default = exports.default;